import { titulosApi } from "../view/titulos.service";

export const editTitulo = titulosApi.injectEndpoints({
  endpoints: (builder) => ({
    editTitulo: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `/v1/api/titulo/${id}/`,
        method: "PATCH",
        body: rest,
      }),
      invalidatesTags: (result, error, { id }) =>
        result
          ? [
              { type: "Titulos", id },
              { type: "Titulos", id: "LIST" },
            ]
          : [{ type: "Titulos", id: "LIST" }],
    }),
  }),
});

export const { useEditTituloMutation } = editTitulo;
